import React from 'react'
import {Component} from 'react'
import './sharing-buttons.scss'

class EmailButton extends Component {
  render(){
    var subject = encodeURIComponent( this.props.shareText )
    var body = encodeURIComponent( this.props.shareText + ' ' + window.location.href )
    var href = "mailto:?subject=" + subject + "&body=" + body
    return (
      <a className="resp-sharing-button__link" href={href} target="_self" aria-label="">
        <div className="resp-sharing-button resp-sharing-button--email resp-sharing-button--small resp-sharing-button__icon resp-sharing-button__icon--solid">
          <i className="fa fa-envelope" />
        </div>
      </a>
    )
  }
}

class FacebookButton extends Component {
  setupFacebookAPI = () => {
    window.fbAsyncInit = function() {
      FB.init({
        appId    : '100216220443749',
        xfbml    : true,
        version  : 'v2.7'
      });
    };

    (function(d, s, id){
       var js, fjs = d.getElementsByTagName(s)[0];
       if (d.getElementById(id)) {return;}
       js = d.createElement(s); js.id = id;
       js.src = "//connect.facebook.net/en_US/sdk.js";
       fjs.parentNode.insertBefore(js, fjs);
     }(document, 'script', 'facebook-jssdk'));
  }
  share = () => {
    FB.ui({
      method: 'feed',
      link: window.location.href,
      name:  this.props.shareText,
      description: this.props.market.about,
      picture: this.props.market.hero
    }, function(response){});
  }
  componentDidMount(){
    this.setupFacebookAPI()
  }
  render(){
    return (
      <span className="resp-sharing-button__link" onClick={this.share} aria-label="">
        <div className="resp-sharing-button resp-sharing-button--facebook resp-sharing-button--small">
          <i className="fab fa-facebook-f" />
        </div>
      </span>
    )
  }
}

class TwitterButton extends Component {
  render(){
    var href = "https://twitter.com/intent/tweet/?" +	"url=" + window.location.href
    if( this.props.shareText ) href = href + "&text=" + encodeURIComponent( this.props.shareText )
    return (
      <a className="resp-sharing-button__link"
        href={href}
        target="_blank" aria-label="">
        <div className="resp-sharing-button resp-sharing-button--twitter resp-sharing-button--small">
          <i className="fab fa-twitter" />
        </div>
      </a>
    )
  }
}

class InstagramButton extends Component {
  render(){
    var href = otg.instagram
    return (
      <a className="resp-sharing-button__link"
        href={href}
        target="_blank" aria-label="">
        <div className="resp-sharing-button resp-sharing-button--instagram resp-sharing-button--small">
          <i className="fab highlight fa-instagram" />
        </div>
      </a>
    )
  }
}

class CopyLinkButton extends Component {
  state = { copied: false }
  copyLink = (e) => {
    copyToClipboard( window.location.href )
    this.setState( { copied: true } )
    setTimeout( this.setState.bind(this, { copied: false } ), 3000 )
  }
  render(){
    var classes = "resp-sharing-button resp-sharing-button--small "
    classes = this.state.copied ? classes + 'resp-sharing-button--copy-clipboard' : classes +	'resp-sharing-button--copy-link'
    return (
      <a className="resp-sharing-button__link"
        onClick={this.copyLink}
        target="_blank" aria-label="">
        <div className={ classes }>
          { this.state.copied ? <i className=" fa fa-check" /> : <i className=" fa fa-link" /> }
        </div>
      </a>
    )
  }
}


export default class extends Component {
  static defaultProps = { className: '' }
  render(){
    return (
      <div className={"sharing-buttons " + this.props.className }>
        <InstagramButton />
      </div>
    )
  }
}
